import { render, staticRenderFns } from "./ProcedureExamCharge.vue?vue&type=template&id=772ad757&scoped=true"
import script from "./ProcedureExamCharge.vue?vue&type=script&lang=js"
export * from "./ProcedureExamCharge.vue?vue&type=script&lang=js"
import style0 from "./ProcedureExamCharge.vue?vue&type=style&index=0&id=772ad757&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772ad757",
  null
  
)

export default component.exports